import moment from 'moment'
import { Popover } from 'antd'

import { ICompanies } from './types'

import { useDeviceType } from '@hooks/useDeviceType'

import { ComponentsHeader } from '@primitive/sectionHeadings'

import imgEmty from '@img/empty.svg'
import imgAccessDenied from '@img/access_denied.svg'
import { IconDownload, IconEntity, IconFiles } from '@img/icons'

import { Empty, Flex, Pagination, Loader, Table, ToolTip, Button, Badge, Container } from '@ui/index'

import css from './ui.module.scss'

/** Контрагенты */
export const Companies = ({
    isLoading, txtSearch, isAccessDenied, currentPageNumber, totalCount, pageSize, companiesList, 
    loadPrimaryData, setTxtSearch, handleOpenCardCompany, handleDownloadFiles, handleOpenModalPreview
}: ICompanies) => {
    const deviceType = useDeviceType()

    return <div className={css['container']}>

        <ComponentsHeader
            isAccessDenied={isAccessDenied.value}
            headerIcon={<IconEntity width="20px" height="20px" />}
            headerTitle="Контрагенты"
            txtSearch={txtSearch}
            txtSearchTooltip={<>Поиск по:<br />✓ Фамилии<br />✓ Имени<br />✓ Отчеству<br />✓ ИНН<br />✓ КПП<br />✓ Наименованию полному<br />✓ Наименованию короткому<br />✓ Адресу<br />✓ Реквизитам</>}
            txtSearchOnChange={(e) => setTxtSearch(e.target.value)}
            txtSearchClearOnClick={() => setTxtSearch('')}
            btnUpdateOnClick={() => loadPrimaryData(txtSearch)}
            btnCreateOnClick={() => handleOpenCardCompany(true, "new")}
        />


        <Table.Container>
            <Loader isOpen={isLoading} backdrop title="Загрузка..." />
            <Table.Header paddingLeft='18px' paddingRight='64px' classNameContainer={css['hidden_550']} classNameContent={css['table_grid_columns_header']}>
                <p style={{textAlign: 'center'}}>№<br/>анкеты</p>
                <p>Наименование контрагента<br />ИНН / КПП контрагента</p>
                <p className={css['hidden_850']}>Ф.И.О. руководителя<br />Юридический адрес контрагента</p>
                <p className={css['hidden_1000']} style={{textAlign: 'center'}}>Дата создания</p>
            </Table.Header>

            <Table.Content>
                {companiesList.length === 0
                    ? <Empty image={isAccessDenied.value ? imgAccessDenied : imgEmty} title={isAccessDenied.value ? 'Доступ запрещён' : 'Данные отсутствуют'} />
                    : companiesList.map((item) => {
                        
                        return (
                            <Table.Row key={item.companyID} className={css['table_grid_columns_row']} onClick={() => handleOpenCardCompany(true, "edit", item.companyID)}>
                                <p style={{textAlign: 'center'}}>{item.companyID}</p>

                                <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                    <p>{item.companyNameShort}</p>
                                    <Flex gap='5px' flexDirection='row'><p style={{ opacity: '.7', color: `${item.companyINN.length > 12 && 'red'}` }}>{item.companyINN}</p> / <p style={{ opacity: '.7' }}>{item.companyKPP || '----'}</p></Flex>
                                </div>

                                <div className={css['hidden_850']} style={{textWrap: 'nowrap', overflow: 'hidden'}}>
                                    <p>{item.lastName} {item.firstName} {item.secondName}</p>
                                    <p style={{ opacity: '.7' }}>{item.address || '----'}</p>
                                </div>

                                <div className={css['hidden_1000']} style={{textAlign: 'center'}}>
                                    <p>{moment(item.dateCreate).format('DD.MM.YYYY')}</p>
                                    <p>{moment(item.dateCreate).format('HH:mm:ss')}</p>
                                </div>

                                <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                    <div style={{position: 'relative'}}>
                                        <Popover content={
                                            item.files.length === 0
                                                ? <Empty image={imgEmty} size='100px' />
                                                : item.files.map((item, index) => (
                                                    <Table.Row key={item.companyFileID} className={css['table_grid_columns_row_file']} onClick={(e) => {handleOpenModalPreview(true, item.filePath, item.fileName); e.stopPropagation()} }>
                                                        <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                            <p>{item.fileName}</p>
                                                            <p style={{ opacity: '.8' }}>Размер файла: {item.fileSize}</p>
                                                        </div>

                                                        <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                                            <ToolTip title='Скачать' placement="bottomRight">
                                                                <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}
                                                                    onClick={(e) => {
                                                                        handleDownloadFiles(item.filePath, item.fileName)
                                                                        e.stopPropagation()}}
                                                                ><IconDownload width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                                            </ToolTip>
                                                        </Flex>
                                                    </Table.Row>
                                                ))
                                        } trigger="click" placement="bottomRight" styles={{ root: { width: '300px' } }}>
                                            <div
                                                onClick={(e) => e.stopPropagation()}
                                                onMouseDown={(e) => e.stopPropagation()}
                                            >
                                                <Button id='tooltipBtnMailings' variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}>
                                                    <IconFiles width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} />
                                                </Button>
                                            </div>
                                        </Popover>

                                        <Badge bottom='-4px' right='-4px' background={item.countFiles === 0 ? 'red' : 'green'}>{item.countFiles}</Badge>
                                    </div>
                                </Flex>
                            </Table.Row>
                        )
                    })
                }
            </Table.Content>
        </Table.Container>

        <Container padding="6px" className={css['footer']} overflow="visible">
            <Flex gap="4px" flexDirection="row">
                <ToolTip title='Общее количество' placement="topLeft">
                    <p className={css['stat_all']}>{totalCount}</p>
                </ToolTip>
            </Flex>

            <Pagination
                totalCount={totalCount}
                pageSize={pageSize}
                currentPage={currentPageNumber.value}
                onChange={(e) => currentPageNumber.setValue(e)}
            />
        </Container>
    </div>
}